import { useContext } from 'react';

import { FieldContext } from './FieldContext.js';

export const useFieldContext = () => {
  const ctx = useContext(FieldContext);

  if (!ctx) {
    throw new Error('useFieldContext must be used within a FieldContextProvider');
  }

  return ctx;
};
